<template>
  <div class="leftMenu" v-loading="loading">
    <TreeMenu
      ref="TreeMenu"
      :menuData="MenuList"
      @select="select"
      :active="activeIndex"
    ></TreeMenu>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TreeMenu from '@/components/TreeMenu/TreeMenu.vue'
export default {
  data() {
    return {
      activeIndex: '',
      MenuList: [],
      loading: false,
    }
  },
  props: {},
  components: { TreeMenu },
  methods: {
    ...mapMutations([
      'setFittingsTreeSearch', // 将 `this.setdevTreeSearch()` 映射为 `this.$store.commit('increment')`
    ]),
    select(index) {
      window.sessionStorage.setItem('FittingsTreeSearch', index)
      this.setFittingsTreeSearch(index)
    },
    getMenuList() {
      this.loading = true
      this.$http
        .post('/PB/PB_MaterialType/GetMaterialTypeTreeData', {})
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.MenuList = resJson.Data
            this.activeIndex =
              window.sessionStorage.getItem('FittingsTreeSearch') || ''
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    MenuSelect() {},
  },
  mounted() {},
  created() {
    this.getMenuList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.leftMenu {
  width: 220px;
  height: 100%;
  overflow-y: auto;
}
</style>
